// extracted by mini-css-extract-plugin
module.exports = {"jcWhite50":"#ffffff","max-width-large":"1024px","maxWidthLarge":"1024px","adminTotpSetup":"AdminTotpSetup__adminTotpSetup"};